var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "step" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          ref: "mountRef",
          staticClass: "drawing",
        },
        [
          !_vm.loading
            ? _c("Slider", {
                staticClass: "tool-bar-slider",
                attrs: { max: "200", value: _vm.drawZoom },
                on: { input: _vm.handleZoomChange },
              })
            : _vm._e(),
          _c("div", { ref: "msgRef" }),
        ],
        1
      ),
      _vm.startSetLayer.visible
        ? _c("NoAuditRoles", {
            attrs: {
              appters: _vm.startSetLayer.appters,
              "user-group": _vm.startSetLayer.userGroup,
            },
            on: {
              "update:visible": function ($event) {
                _vm.startSetLayer.visible = $event
              },
              "click:ok": _vm.handleSetOk,
            },
          })
        : _vm._e(),
      _vm.auditRoleLayer.visible
        ? _c("DrawerAuditRole", {
            attrs: {
              "tmpl-code": _vm.tmplCode,
              default: _vm.auditRoleLayer.default,
            },
            on: {
              "update:visible": function ($event) {
                _vm.auditRoleLayer.visible = $event
              },
              "click:ok": _vm.handleAuditRoleOk,
            },
          })
        : _vm._e(),
      _vm.optionalRoleLayer.visible
        ? _c("DrawerOptionalRole", {
            attrs: { default: _vm.optionalRoleLayer.default },
            on: {
              "update:visible": function ($event) {
                _vm.optionalRoleLayer.visible = $event
              },
              "click:ok": _vm.handleOptionalRoleOk,
            },
          })
        : _vm._e(),
      _vm.assignRoleLayer.visible
        ? _c("DrawerAssignRole", {
            attrs: { default: _vm.assignRoleLayer.default },
            on: {
              "update:visible": function ($event) {
                _vm.assignRoleLayer.visible = $event
              },
              "click:ok": _vm.handleAssignRoleOk,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }